import { render, staticRenderFns } from "./DeletePlan.vue?vue&type=template&id=2a304ae6&scoped=true"
import script from "./DeletePlan.vue?vue&type=script&lang=js"
export * from "./DeletePlan.vue?vue&type=script&lang=js"
import style0 from "./DeletePlan.vue?vue&type=style&index=0&id=2a304ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a304ae6",
  null
  
)

export default component.exports